import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { useRouter } from 'next/router';
import openAPIErrorNotification from '@/shared/APIErrorNotification/APIErrorNotification';
import createAndEnrollStudent from '@/api/enrollment/createAndEnrollStudent.endpoint';

export default function useConfirmPossibleDuplicate({
  flowActions,
  flowState,
}) {
  const router = useRouter();
  const { state, actions } = useCustomHook({
    defaultState: { loading: false },
    actions: {
      goToDuplicateLogin: (student) => {
        flowActions.setStudentData({
          ...flowState.studentData,
          selectedDuplicate: student.ssoProviders[0].ssoId,
        });
        flowActions.setActiveStep('duplicateLogin');
      },
      confirmUserCreationAndEnroll: async (student) => {
        actions.setState({ loading: true });
        try {
          const response = await createAndEnrollStudent(
            flowState.class.enrollmentCode,
            {
              firstName: flowState.studentData.firstName,
              lastName: flowState.studentData.lastName,
              password: flowState.studentData.password,
              forceCreate: true,
            }
          );
          flowActions.setCredentials({
            username: response.ssoId,
            password: flowState.studentData.password,
          });
          flowActions.setActiveStep('success');
        } catch (error) {
          console.log(error);
          openAPIErrorNotification({
            title: 'There was an error',
            description: 'There was a problem with the enrollment',
            errorFeedback: error.feedbackData,
          });
          actions.setState({
            loading: false,
          });
        }
      },
      goBack: () => {
        flowActions.setActiveStep('createAndEnrollStudent');
      },
    },
  });

  return { state, actions };
}
